// extracted by mini-css-extract-plugin
export default {"btnsec":"CopyRequest_btnsec__Demir","copy-request-btn":"CopyRequest_copy-request-btn__S-e0s"};